module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"今後のタイムライン(来店客数)","prediction_timeline_tooltip1":"今後の来店客数予測を表します。","Mon":"月","Tue":"火","Wed":"水","Thu":"木","Fri":"金","Sat":"土","Sun":"日","dayUnit":"日","Current":"現在","Prediction":"予測","Traffic":"来店客数"}}')
  delete Component.options._Ctor
}
